import { getPageURLFromBrowser, getPageReferer } from '../commonAttributes';
import { pushEvent } from '../dataLayer';
import { EVENT_TYPES } from '../../constants/eventTypes';
import CustomConfig from '../../configuration/customConfig';
import { GlobalStorage } from '../../utils/global';
import { CustomEventData } from '../../constants/customEventDataModel';
import { CUSTOM_EVENT_CONTENT_TYPES } from '../../constants/customEventContentTypes';

/**
 * Determines the current URL and pushes a pageview event to the DataLayer with the appropriate values.
 */
export function trackPageview() {
  pushEvent({
    eventType: EVENT_TYPES.PAGE_VIEW,
    pageURL: getPageURLFromBrowser(),
    eventTimestamp: Date.now(),
    pageReferer: getPageReferer(),
  });
}

/**
 * This function is used to create the customPageview event.
 * @param customEventData the information about the custom event
 */
export function trackCustomPageview(customEventData: CustomEventData) {
  if (
    customEventData?.page?.pageURL &&
    pushEvent({
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventContentType: CUSTOM_EVENT_CONTENT_TYPES.CUSTOM_PAGEVIEW,
      pageURL: customEventData.page.pageURL,
      eventName: customEventData.event.name,
      eventTimestamp: Date.now(),
      pageReferer: getPageReferer(),
      pageName: customEventData.page.pageName,
      description: customEventData.event.description,
      customData: customEventData.data,
    })
  ) {
    // Only set previousPageURL on successful pushEvent calls
    GlobalStorage.set(GlobalStorage.PREVIOUS_PAGE_URL, customEventData.page.pageURL);
  }
}
